import { render, staticRenderFns } from "./MappingsList.vue?vue&type=template&id=52b9b691"
import script from "./MappingsList.vue?vue&type=script&lang=js"
export * from "./MappingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports